import React from "react";
import S from './Expertise.module.scss';

export const Expertise = () => {
  return (
    <div className={S.root} id='about'>
      <div className={S.elements}>
        <h1 className={S.title}><span>Экспертиза</span> и технологии</h1>
        <div className={S.description}>
          <p>Команда БМК Софт обладает опытом разработки и внедрения цифровых решений для предприятий
            промышленного сектора. Мы реализуем полный цикл проектов — от анализа бизнес-процессов до
            внедрения и сопровождения систем.</p>
        </div>
        <div className={S.groupParagraph}>
          <div className={S.boxParagraphUp}>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>1</div>
              <div className={S.paragraphText}>исследование бизнес-процессов<br/> предприятия</div>
            </div>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>2</div>
              <div className={S.paragraphText}>искусственный интеллект<br/> и аналитика данных</div>
            </div>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>3</div>
              <div className={S.paragraphText}>интеграция с корпоративными<br/> системами и сервисами</div>
            </div>
          </div>
          <div className={S.boxParagraphBottom}>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>4</div>
              <div className={S.paragraphText}>информационная безопасность<br/> и отказоустойчивость решений</div>
            </div>
            <div className={S.paragraph}>
              <div className={S.boxNumber}>5</div>
              <div className={S.paragraphText}>современный технологический стек<br/> и облачная инфраструктура</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};